<template>
  <div class="p-1">
    <div-table :config="configList" :data="avances" :idWharhouse="idWharhouse" :currentUser="currentUser" :limit="limit"
      @reset="reset" @refresh="refresh" @filtrer="filtrer" @search="search" :loading="loading" :paginate="paginate"
      @paginatation="paginatation" @Changelimit="Changelimit"></div-table>
  </div>
</template>

<script>
import config from "./config";
export default {
  props: {
    currentUser: { type: Object },
    idWharhouse: { type: Object },
  },
  data() {
    return {
      configList: config.list,
      loading: false,
      formData: {},
      avances: [],
      users: [],
      tabId: [],
      limit: 10,
      filters: {},
      typeEmployeurs: [],
      settingDetails: [],
      paginate: {
        total: 0,
        currentpage: 1,
        lastpage: 0,
        per_page: 0,
      },
    };
  },
  computed: {
    warhouseSelected() {
      return this.$store.getters["wharhouse/warhouseSelected"]({
        user: _.pick(this.currentUser, ["countries"]),
      });
    },
  },
  watch: {
    warhouseSelected: async function (oldVal, newVal) { },
    idWharhouse: async function (oldVal, newVal) {
      this.idWharhouse = oldVal;
      await this.reset();
      this.checkTypeEmployeurs();
      await this.getPosts();
      this.setDataSelect("user", this.users, null);
    },
  },
  async mounted() {
    if (this.$f.QueryStringToobject())
      this.filters = this.$f.QueryStringToobject();
    else
      this.$f.objectToQueryString({
        limit: this.limit,
        "warehouse._id": this.idWharhouse._id,
      });

    if (this.filters.name) await this.search(this.filters.name);
    else await this.getAvoirs(this.filters);

    const { content: data } = await this.$server.get("settings");
    this.settingDetails = data.details;
    this.checkTypeEmployeurs();

    await this.getPosts();
    this.setDataSelect("user", this.users, null);
    this.setDataSelect("status", ["not applied", "applied"], null);
    this.setDataSelect("type", ["avance", "prime"], null);
  },
  methods: {
    checkTypeEmployeurs() {
      const currentSettingW = this.getElementInArray(
        this.settingDetails,
        this.idWharhouse._id
      );
      this.typeEmployeurs = currentSettingW.salaries.map((el) => el.type);
    },
    getElementInArray(data, value) {
      var result = data.filter(function (o) {
        let whar = o.warehouse;
        if (o.warehouse._id) whar = o.warehouse._id;
        return whar == value.toString();
      });
      return result ? result[0] : null; // or undefined
    },
    setDataSelect(model, data, splice) {
      for (var i = 0; i < this.configList.filters.elements.champs.length; i++) {
        if (
          this.configList.filters.elements.champs[i].type === "select" &&
          this.configList.filters.elements.champs[i].key === model
        ) {
          if (!splice) {
            this.configList.filters.elements.champs[i].values = data;
          } else {
            this.configList.filters.elements.champs.splice(i, 1);
          }
        }
      }
    },
    async getPosts() {
      const filter = {
        type: this.typeEmployeurs,
        countries: this.idWharhouse.country,
        limit: 100,
      };
      if (this.currentUser.type != "Seller") {
        const res = await this.$server.search("users", filter);
        if (res.content.results) this.users = res.content.results;
        else this.users = [];
      }
    },
    async Changelimit(val) {
      if (this.$f.QueryStringToobject())
        this.filters = this.$f.QueryStringToobject();
      this.filters["limit"] = val;
      this.filters["page"] = 1;
      this.paginate.currentpage = 1;
      this.$f.objectToQueryString(this.filters);
      if (this.filters.name) await this.search(this.filters.name);
      else this.getAvoirs(this.filters);
    },
    async filtrer(data) {
      if (this.$f.QueryStringToobject())
        this.filters = this.$f.QueryStringToobject();
      delete this.filters.page;
      delete this.filters.name;

      console.log("filter search________", data);
      this.paginate.currentpage = 1;
      if (!this.filters["limit"]) this.filters["limit"] = this.limit;
      if (data.user) {
        this.filters.user = data.user._id;
      } else delete this.filters.user;
      if (data.status) {
        this.filters.status = data.status;
      } else delete this.filters.status;
      if (data.type) {
        this.filters.type = data.type;
      } else delete this.filters.type;
      if (data.Range_date && data.Range_date[0]) {
        this.filters.Range_date = data.Range_date.map((el) =>
          this.$moment(el).format("yyyy-MM-DD")
        );
      } else delete this.filters.Range_date;
      this.$f.objectToQueryString(this.filters);
      await this.getAvoirs(this.filters);
    },
    /**********************************User and Status******************************************************/
    async getUser() {
      const res = await this.$me;
      this.currentUser = res.content;
      console.log(res.content);
    },

    async reset() {
      let lmitt = this.limit;
      if (this.$f.QueryStringToobject())
        this.filters = this.$f.QueryStringToobject();
      if (this.filters["limit"]) lmitt = this.filters["limit"];
      this.filters["page"] = 1;
      this.$f.objectToQueryString({
        limit: lmitt,
        "warehouse._id": this.idWharhouse._id,
      });
      await this.getAvoirs({ limit: lmitt });
    },
    async refresh() {
      if (this.$f.QueryStringToobject())
        this.filters = this.$f.QueryStringToobject();
      this.$f.objectToQueryString(this.filters);
      if (this.filters.name) await this.search(this.filters.name);
      else await this.getAvoirs(this.filters);
      if (
        this.filters["page"] &&
        this.filters["page"] > 1 &&
        this.avances.length == 0
      ) {
        this.filters["page"] = --this.filters["page"];
        this.$f.objectToQueryString(this.filters);
        await this.getAvoirs(this.filters);
      }
    },
    async getAvoirs(filters) {
      this.loading = true;
      filters["warehouse._id"] = this.idWharhouse._id;
      const res = await this.$server.search("avances", filters);
      this.loading = false;
      if (res && res.content.results) {
        this.avances = res.content.results;
        this.avances.forEach(
          function (avoir) {
            if (avoir.salarie && avoir.salarie._id) {
              avoir.salarie =
                '<a class="text-blue-600" target="_blank" href="/salaries/view/' +
                avoir.salarie._id +
                '"><svg class="fill-current" width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M14 4h-13v18h20v-11h1v12h-22v-20h14v1zm10 5h-1v-6.293l-11.646 11.647-.708-.708 11.647-11.646h-6.293v-1h8v8z"/></svg></a>';
              avoir.status = "applied";
            }
          }.bind(this)
        );
        this.paginate.total = res.content.total;
        this.paginate.lastpage = res.content.last_page;
        this.paginate.per_page = res.content.per_page;
        this.paginate.currentpage = res.content.current_page;
      } else {
        this.avances = [];
        this.paginate = { total: 0, currentpage: 1, lastpage: 1, per_page: 0 };
      }
    },
    async search(data) {
      this.paginate = { total: 0, currentpage: 1, lastpage: 1, per_page: 0 };
      let limitt = this.limit;
      if (this.filters["limit"]) limitt = this.filters["limit"];
      const search = {
        name: data.trim(),
        limit: parseInt(limitt),
        "warehouse._id": this.idWharhouse._id,
      };

      this.$f.objectToQueryString(search);
      const res = await this.$server.find("avances", search);
      if (res.content.results) {
        this.avances = res.content.results;
        this.avances.forEach(
          function (avoir) {
            if (avoir.salarie && avoir.salarie._id) {
              avoir.status = "applied";
              avoir.salarie =
                '<a class="text-blue-600" target="_blank" href="/salaries/view/' +
                avoir.salarie._id +
                '"><svg class="fill-current" width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M14 4h-13v18h20v-11h1v12h-22v-20h14v1zm10 5h-1v-6.293l-11.646 11.647-.708-.708 11.647-11.646h-6.293v-1h8v8z"/></svg></a>';
            }
          }.bind(this)
        );
        this.paginate.total = res.content.total;
        this.paginate.lastpage = res.content.last_page;
        this.paginate.per_page = res.content.per_page;
        this.paginate.currentpage = res.content.current_page;
      } else {
        this.avances = [];
        this.paginate = { total: 0, currentpage: 1, lastpage: 1, per_page: 0 };
      }
    },
    async remove(id) {
      this.$confirm("You want to delete this avoir?").then(async (res) => {
        if (res) {
          const resp = await this.$server.delete("avances", { id: id });
          await this.refresh();
          alert("avoir Deleted", "success");
        }
      });
    },
    /********************************************************************************************/
    async paginatation(direction) {
      var page = 0;
      if (direction == "next") {
        page = ++this.paginate.currentpage;
      } else {
        page = --this.paginate.currentpage;
      }
      if (this.$f.QueryStringToobject())
        this.filters = this.$f.QueryStringToobject();
      this.filters["page"] = page;
      this.$f.objectToQueryString(this.filters);

      this.getAvoirs(this.filters);
    },
  },
};
</script>

<style>
/* animation for vue transition tag */
</style>
